import jsCookie from 'js-cookie';
import { jwtCookieName } from 'types/accessControl/AccessControlConstants';

export const removeSpruceJWTCookie = () => jsCookie.remove(jwtCookieName);
